import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Utente } from "@/types/api";

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => apiFetch<Utente>("/api/v1/me"),
    staleTime: 5 * 60_000,
  });
}
